/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramUsersModeratorControllerFindManyQueryResponse,
  TelegramUsersModeratorControllerFindManyQueryParams,
  TelegramUsersModeratorControllerFindMany401,
} from '../../types/TelegramUsersModeratorControllerFindMany.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramUsersModeratorFindMany } from '../../methods/telegramUsersModeratorFindMany.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramUsersModeratorFindManyQueryKey = (params?: TelegramUsersModeratorControllerFindManyQueryParams) =>
  [{ url: '/api/moderator/telegram/users' }, ...(params ? [params] : [])] as const;

export type TelegramUsersModeratorFindManyQueryKey = ReturnType<typeof telegramUsersModeratorFindManyQueryKey>;

export function telegramUsersModeratorFindManyQueryOptions(
  params?: TelegramUsersModeratorControllerFindManyQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramUsersModeratorFindManyQueryKey(params);
  return queryOptions<
    TelegramUsersModeratorControllerFindManyQueryResponse,
    ResponseErrorConfig<TelegramUsersModeratorControllerFindMany401>,
    TelegramUsersModeratorControllerFindManyQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramUsersModeratorFindMany(params, config);
    },
  });
}

/**
 * {@link /api/moderator/telegram/users}
 */
export function useTelegramUsersModeratorFindMany<
  TData = TelegramUsersModeratorControllerFindManyQueryResponse,
  TQueryData = TelegramUsersModeratorControllerFindManyQueryResponse,
  TQueryKey extends QueryKey = TelegramUsersModeratorFindManyQueryKey,
>(
  params?: TelegramUsersModeratorControllerFindManyQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramUsersModeratorControllerFindManyQueryResponse,
        ResponseErrorConfig<TelegramUsersModeratorControllerFindMany401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramUsersModeratorFindManyQueryKey(params);

  const query = useQuery(
    {
      ...telegramUsersModeratorFindManyQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<TelegramUsersModeratorControllerFindMany401>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
